/**
 * Column Utility Functions
 * 
 * Shared utilities for task column components to eliminate code duplication.
 */

import { extractBaseColor } from '../../../../utils/colorUtils';
import { COLUMN_TO_BORDER_COLOR_MAP } from '../../../../constants/colorConstants';

/**
 * Get text color class from column color
 * Shared utility to eliminate duplication across DroppableTaskColumn, 
 * DeadlineSortedTaskBoard, and DeadlineSortedTaskColumn components
 */
export function getColumnTextColorClass(columnColor: string | null | undefined): string {
  if (!columnColor) return 'text-gray-600';

  // Try direct lookup first
  const directTextColor = COLUMN_TO_BORDER_COLOR_MAP[columnColor]?.replace('border-', 'text-');
  if (directTextColor) return directTextColor;

  // Extract base color and try again
  const baseColor = extractBaseColor(columnColor);
  if (baseColor) {
    const baseTextColor = COLUMN_TO_BORDER_COLOR_MAP[baseColor]?.replace('border-', 'text-');
    if (baseTextColor) return baseTextColor;
  }

  // Default fallback
  return 'text-gray-600';
}